module.exports = __webpack_public_path__ + "img/solidWaste.b96eeaa9.png";